<app-unauthorized-layout>
  <div class="login-container forgot-password-container">
    <app-auth-left-panel
      [imageSrc]="'assets/images/airport.png'"
      imageAlt="Airport" class="login-image">
    </app-auth-left-panel>
    <div class="login-form-section">
    <img src="assets/images/logo.png" alt="Civil Aviation Authority" class="login-logo" />

    <div class="forgot-password-card">
      <!-- Header -->
      <div class="text-center mb-4">
        <i class="bi bi-key" style="font-size: 3rem; color: #667eea;"></i>
        <h2 class="fw-bold text-dark mt-3">{{ 'forgotPassword.title' | translate }}</h2>
        <p class="text-muted">{{ 'forgotPassword.subtitle' | translate }}</p>
      </div>

      <!-- Success Message -->
      @if (successMessage) {
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          <i class="bi bi-check-circle m-2"></i>
          <strong>{{ 'common.success' | translate }}</strong>
          <p class="mt-2 mb-0">{{ successMessage }}</p>
        </div>
      }

      <!-- Error Message -->
      @if (errorMessage) {
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
          <i class="bi bi-exclamation-triangle m-2"></i>
          <strong>{{ 'common.error' | translate }}</strong>
          <p class="mt-2 mb-0">{{ errorMessage }}</p>
          <button type="button" class="btn-close" (click)="errorMessage = null"></button>
        </div>
      }

      <!-- Info Message -->
      <div class="alert alert-info mb-4" role="alert">
        <i class="bi bi-info-circle m-2"></i>
        {{ 'forgotPassword.checkEmail' | translate }}
      </div>

      <!-- Forgot Password Form -->
      @if (!successMessage) {
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <!-- Email Field -->
          <div class="mb-3">
            <label for="email" class="form-label fw-semibold">{{ 'forgotPassword.email' | translate }} <span class="text-danger">*</span></label>
            <input
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
              placeholder="Enter your email address"
              [class.is-invalid]="getFieldError('email') !== null">
              @if (getFieldError('email')) {
                <div class="invalid-feedback d-block">
                  {{ getFieldError('email') }}
                </div>
              }
            </div>
            <!-- Submit Button -->
            <button
              type="submit"
              class="btn btn-primary w-100 btn-lg fw-semibold mb-3"
              [disabled]="isLoading || form.invalid">
              @if (!isLoading) {
                <span>{{ 'forgotPassword.sendButton' | translate }}</span>
              }
              @if (isLoading) {
                <span>
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ 'common.loading' | translate }}
                </span>
              }
            </button>
          </form>
        }

        <!-- Back to Login -->
        <div class="text-center">
          <p class="text-muted mb-0">{{ 'forgotPassword.rememberPassword' | translate }}</p>
          <a href="/login" class="btn btn-link p-0">{{ 'forgotPassword.backToLogin' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</app-unauthorized-layout>
